import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { TriggerButtonMixin } from '../../mixins/components/TriggerButtonMixin';
import { IconHelp } from '../Icon/index';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';

/**
 * A standalone component for opening `Tooltip` and `Popover` components.
 *
 * The default child for `Popper` and `Trigger`.
 *
 * @related ['Popover', 'Tooltip', 'Trigger', 'TriggerText']
 * @since 7.0.0
 */
var TriggerButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "TriggerButton",
  componentId: "c11n-8-111-1__sc-p0gsxu-0"
})(["", ""], TriggerButtonMixin);
TriggerButton.displayName = 'TriggerButton';
TriggerButton.propTypes = {
  /**
   * The trigger's button content.
   */
  children: PropTypes.node,
  /**
   * The trigger's button type attribute.
   */
  type: PropTypes.string
};
TriggerButton.defaultProps = {
  children: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(IconHelp, {
    size: "xs"
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, "Help")),
  // Prevents submits when included in a form tag
  type: 'button'
};

/** @component */
export { TriggerButton };